export const removeHTMLTags = (htmlString) => {
  const element = document.createElement('div')
  element.innerHTML = htmlString
  const text = element.textContent || element.innerText || ''

  return text
}
